import { NgModule, ModuleWithProviders } from '@angular/core';

import { QueryService, QUERY_CONFIG } from '@relevance/angular-core';

import { SearchServiceConfig, SEARCH_CONFIG } from './search.config';
import { SearchService } from './search.service';

@NgModule()
export class SearchModule {

  static forRoot(config: SearchServiceConfig): ModuleWithProviders<SearchModule> {
    return {
      ngModule: SearchModule,
      providers: [
        QueryService,
        SearchService,
        {
          provide: SEARCH_CONFIG,
          useValue: config,
        },
        {
          provide: QUERY_CONFIG,
          useValue: config.queryConfig,
        },
      ],
    };
  }

  static forChild(config: SearchServiceConfig): ModuleWithProviders<SearchModule> {
    return SearchModule.forRoot(config);
  }

}
